import { render, staticRenderFns } from "./PlaylistTabStatistics.vue?vue&type=template&id=4638cadd&"
import script from "./PlaylistTabStatistics.vue?vue&type=script&lang=js&"
export * from "./PlaylistTabStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports